import { useGroupRules, UserGroupRules } from 'src/graphql';
import { useSidekickTransition } from 'src/utils/navigation/use-sidekick-transition';

export interface NavTabVisibility {
  showInboxTab: boolean;
  showSearchTab: boolean;
  showSidekickTab: boolean;
}

export const useNavTabVisibility = (): NavTabVisibility => {
  const { checkValidity, loading: rulesLoading } = useGroupRules();
  const { hasTransitioned } = useSidekickTransition();

  return {
    showInboxTab: !rulesLoading ? checkValidity([UserGroupRules.AccessToInbox]) : false,
    showSearchTab: !rulesLoading
      ? checkValidity([UserGroupRules.AccessToViewConversations])
      : false,
    // Sidekick always carries Help, so no rule gates the tab; before the move the
    // bottom bar owns the entry point
    showSidekickTab: hasTransitioned,
  };
};
